import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IReisekostenabrechnungStatusSorter extends ISorter {
  id?: ISorterExpression;
  name?: ISorterExpression;
  kommentar?: ISorterExpression;
}

export const ReisekostenabrechnungStatusSorterConfig: ISorterConfig = [
  SorterConfig('id', 'Id'),
  SorterConfig('name', 'Name'),
  SorterConfig('kommentar', 'Kommentar')
];
